import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import majors from '../../../NewOffer/components/Form/majors';
import FacebookIcon from '@material-ui/icons/Facebook';
import GithubIcon from '@material-ui/icons/GitHub';
import LinkedinIcon from '@material-ui/icons/LinkedIn';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField
} from '@material-ui/core';
import {getUserEditableDataAPIReq, postUserEditableDataAPIReq} from '../../../../utils/requests';
import CircularProgress from '@material-ui/core/CircularProgress';
import MyOffers from '../../../MyOffers';

const useStyles = makeStyles(() => ({
  root: {}
}));


const getUserEditableData = async (isLoading, setIsLoading, setValues) =>{
  if(isLoading){
    return getUserEditableDataAPIReq()
      .then((res) => {
        if(res[0]){
          setIsLoading(false);
          // console.log(res[1])
          if(res[1].is_alumni)
            res[1].email = res[1].aui_id + '@alumni.aui.ma';
          else
            res[1].email = res[1].aui_id + 'aui.ma';
          setValues(res[1]);
        } else{
          alert('An arror happened while fetching for data');
        }
      })
  }
}


const AccountDetails = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true)
  const [values, setValues] = useState({
    first_name: '',
    last_name: '',
    school: '',
    email: '',
    major: '',
    minor: '',
    phone_number: '',
    accountCreationDate: '',
    linkedin_username: '',
    github_username: ''
  });

  const handleSaveChangesClick = event => {
    event.preventDefault();
    setIsLoading(true);
    // console.log(values.github_username)
    return postUserEditableDataAPIReq(values.first_name, values.last_name, values.phone_number, values.school, values.major, values.minor, 3, values.current_job, values.cv_url, values.linkedin_username, values.github_username)
      .then((status) => {
        if(status){
          setIsLoading(false);
        } else{
          alert('An arror happened while modifying your details');
        }
      })
  };


  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };
  const schools = [
    {
      value: 'SBA',
      label: 'School of business and administration'
    },
    {
      value: 'SHSS',
      label: 'School of Humanities and Social Sciences'
    },
    {
      value: 'SSE',
      label: 'School of Science and Engineering'
    }
  ];


  getUserEditableData(isLoading, setIsLoading, setValues);
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      {isLoading ?
        <div
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            marginTop: '200px',
            marginBottom: '200px'
          }}
        >
          <CircularProgress disableShrink/>
        </div>
        :
        <form
          autoComplete="off"
          noValidate
        >
          <CardHeader
            subheader="The information can be edited"
            title="Profile"
          />
          <Divider/>
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the first name"
                  label="First name"
                  margin="dense"
                  name="first_name"
                  onChange={handleChange}
                  required
                  value={values.first_name}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Last name"
                  margin="dense"
                  name="last_name"
                  onChange={handleChange}
                  required
                  value={values.last_name}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  disabled
                  fullWidth
                  label="Email Address"
                  margin="dense"
                  name="email"
                  onChange={handleChange}
                  value={values.email}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Phone Number"
                  margin="dense"
                  name="phone_number"
                  onChange={handleChange}
                  type="number"
                  value={values.phone_number}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="School"
                  margin="dense"
                  name="school"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{native: true}}
                  value={values.school}
                  variant="outlined"
                >
                  {schools.map(option => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Major"
                  margin="dense"
                  name="major"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{native: true}}
                  value={values.major}
                  variant="outlined"
                >
                  {majors.map(option => (
                    <option
                      key={option.code}
                      value={option.code}
                    >
                      {option.major_name}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Minor"
                  margin="dense"
                  name="minor"
                  onChange={handleChange}
                  value={values.minor}
                  variant="outlined"
                />
              </Grid>

              <Grid
                alignItems="center"
                container
                style={{marginTop: 5}}
              >
                <Grid item  >
                  <LinkedinIcon/>
                </Grid>
                <Grid
                  item
                  md={11}
                  xs={11}
                >
                  <TextField
                    fullWidth
                    label="LinkedIn Username"
                    margin="dense"
                    name="linkedin_username"
                    onChange={handleChange}
                    value={values.linkedin_username}
                    variant="outlined"
                  />
                </Grid>
              </Grid>


              <Grid
                alignItems="center"
                container
                style={{marginTop: 10}}
              >
                <Grid item  >
                  <GithubIcon/>
                </Grid>
                <Grid
                  item
                  md={11}
                  xs={11}
                >
                  <TextField
                    fullWidth
                    label="GitHub Username"
                    margin="dense"
                    name="github_username"
                    onChange={handleChange}
                    value={values.github_username}
                    variant="outlined"
                  />
                </Grid>
              </Grid>



            </Grid>
          </CardContent>
          <Divider/>
          <CardActions style={{flexDirection: 'row-reverse'}}>
            <Button

              color="primary"
              onClick={handleSaveChangesClick}
              variant="contained"
            >
              Save details
            </Button>
          </CardActions>
        </form>
      }
    </Card>
  );
};

AccountDetails.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array
};

export default AccountDetails;
